import { FormKeys } from '@chilipiper/design-system'
import { AppearanceSettings } from './api-queries/botAndDataFieldsVisibilitySettings'

export const defaultAppearanceSettings: AppearanceSettings = {
  actionColor: 'rgb(84, 61, 255)',
  sideSpacing: 24,
  bottomSpacing: 24,
  themeMode: 'light',
  customTriggers: { drafts: [], published: [] },
  launcherPosition: 'right',
  companyName: '',
  dataFieldsVisiblity: {},
  consentFooter: {
    text: "Chili Piper provides this chat. You agree this chat may be recorded. See Chili Piper's Privacy Statement.",
    links: [
      {
        text: "Chili Piper's Privacy Statement",
        url: 'https://www.chilipiper.com/privacy-policy',
      },
    ],
  },
}

export const storybookDarkAppearanceSettings: AppearanceSettings = {
  actionColor: 'rgb(255,230,210)',
  sideSpacing: 24,
  bottomSpacing: 24,
  customTriggers: { drafts: [], published: [] },
  themeMode: 'dark',
  launcherPosition: 'right',
  companyName: '',
  dataFieldsVisiblity: {},
  consentFooter: {
    text: "Chili Piper provides this chat. You agree this chat may be recorded. See Chili Piper's Privacy Statement.",
    links: [
      {
        text: "Chili Piper's Privacy Statement",
        url: 'https://www.chilipiper.com/privacy-policy',
      },
    ],
  },
}

export const storybookLightAppearanceSettings: AppearanceSettings = {
  actionColor: 'rgb(120,0,120)',
  sideSpacing: 24,
  bottomSpacing: 24,
  customTriggers: { drafts: [], published: [] },
  themeMode: 'light',
  launcherPosition: 'right',
  companyName: '',
  dataFieldsVisiblity: {},
  consentFooter: {
    text: "Chili Piper provides this chat. You agree this chat may be recorded. See Chili Piper's Privacy Statement.",
    links: [
      {
        text: "Chili Piper's Privacy Statement",
        url: 'https://www.chilipiper.com/privacy-policy',
      },
    ],
  },
}

const createFormKeysFromDefaultValues = <T extends object>(defaultValues: T) =>
  Object.keys(defaultValues).reduce((acc, key) => ({ ...acc, [key]: key }), {} as FormKeys<T>)

export const settingsFormKeys = createFormKeysFromDefaultValues(defaultAppearanceSettings)
